import { FC } from "react";
import { Route, Switch } from "react-router-dom";
import routes from "./routespath";
import PrivateRoute from "../Authorization/protectedRoute";
import Login from "../Components/Login/login";
import SigninOidc from "../Components/Login/signin-oidc";
import SignoutOidc from "../Components/Login/signout-oidc";
import SigninSilentCallBack from "../Components/Login/silentCallBack";
import { useSelector } from "react-redux";
import { LOCAL_STORAGE_CONSTANTS } from "../Constants/constants";

const Routes: FC<any> = (authContext) => {
  const user = useSelector((state: any) => state.auth.user);

  if (window.performance) {
    if (performance.navigation.type == 1) {
      localStorage.setItem(LOCAL_STORAGE_CONSTANTS.IS_RELOAD, "true");
    } else {
      localStorage.setItem(LOCAL_STORAGE_CONSTANTS.IS_RELOAD, "false");
    }
  }

  return (
    <>
      <Switch>
        {user !== undefined &&
          user !== null &&
          routes.map(
            (
              {
                path,
                loader,
                component,
                hasLinkAccess,
                name,
                nestedRoutedParent,
              },
              index
            ) => {
              return (
                <PrivateRoute
                  key={path}
                  path={path}
                  component={component}
                  nestedRoutedParent={nestedRoutedParent}
                  routes={routes}
                />
              );
            }
          )}
        <Route path="/silent-callback" component={SigninSilentCallBack} />
        <Route path="/signout-oidc" component={SignoutOidc} />
        <Route path="/signin-oidc" component={SigninOidc} />
        <Route path="/login" component={Login} />
        <Route path="/" component={Login} />
      </Switch>
    </>
  );
};

export default Routes;
